import { Dispatch } from "react";
import { DOCUMENTOS_TYPES } from "../../constants/documentos.types";
import { State } from "../../reducers";
import { generalOpenModalInfo, generalShowLoader } from "../general.actions";
import { getActividadesEconomicas, getDepartamentos, getTiposDocumento } from "../catalogos.actions";
import { facturacionGetDatosEmisor } from "../facturacion/facturacionEmision.actions";
import { validacionesHandleChangeGeneral, validacionesOnBlurGeneral } from "../gestion-usuario/gu-generales/gu-generales";

export const docsFormSetChange = (form: any) => ({
  type: DOCUMENTOS_TYPES.FORMDOCS_HANDLE_CHANGE,
  payload: form,
})

export const docsSetFormErrors = (errors: any) => ({
  type: DOCUMENTOS_TYPES.FORMDOCS_SET_ERRORS,
  payload: errors,
})

export const docsSetDocsAsociados = (dataDocs: any) => ({
  type: DOCUMENTOS_TYPES.DATADOCS_SET_ASOCIADOS,
  payload: dataDocs,
})

export const docsAsociadosReset = () => ({
  type: DOCUMENTOS_TYPES.DATADOCS_RESET_MODULE,
  payload: null,
})

// DATOS RECEPTOR
export const docsDatosReceptorHandleChange = (data: any) => ({ type: DOCUMENTOS_TYPES.DOCS_RECEPTOR_HANDLE_CHANGE, payload: data, })
export const docsDatosReceptorSetErrors = (errors: any) => ({ type: DOCUMENTOS_TYPES.DOCS_RECEPTOR_SET_ERRORS, payload: errors, })
export const docsDatosReceptorReset = () => ({ type: DOCUMENTOS_TYPES.DOCS_RECEPTOR_RESET_MODULE,  payload: null, })
export const docsDatosReceptorHistorialHandleChange = (data: any) => ({ type: DOCUMENTOS_TYPES.DOCS_RECEPTOR_HISTORIAL_HANDLE_CHANGE, payload: data, })

export const docsFormHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<any>, getState: () => State) => {
    let {name, value} = e.target
    
    if (value) {
      switch (name) {
        default:
          break
      }
    }

    dispatch(docsFormSetChange({[name]: value}))
  }

export const setActiveModuleDoc = (activeDoc: any) => ({
  type: DOCUMENTOS_TYPES.DOCS_ACTIVE_MODULE,
  payload: activeDoc,
})

export const documentosConsultarCatalogos = () => async (dispatch: Dispatch<any>, getState: () => State) => {
  dispatch(generalShowLoader(true))
  try {
    await dispatch(getDepartamentos());
    await dispatch(getTiposDocumento());
    await dispatch(getActividadesEconomicas());
    await dispatch(facturacionGetDatosEmisor());
  } catch (error) {}
  dispatch(generalShowLoader(false))
}

export const docsDatosReceptorHandleChangeInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => async (dispatch: Dispatch<any>, getState: () => State) => {  
  let {name, value} = e.target
  if (!validacionesHandleChangeGeneral(name, value, getState().documentos.datosReceptor.form.tipoDocumento)) return
  dispatch(docsDatosReceptorHandleChange({[name]: value}))
}

export const docsDatosReceptorOnBlurInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => async (dispatch: Dispatch<any>, getState: () => State) => {
  let {name, value} = e.target
  if(name === "tipoDocumento" && value) {
    const tipoDoc = getState().catalogos.tipoDocumento.find((doc) => value === doc.codigo)
    if (tipoDoc) dispatch(docsDatosReceptorHandleChange({nombreTipoDocumento: tipoDoc.valor}))    
  }
  let message = validacionesOnBlurGeneral(name, value, getState().documentos.datosReceptor.form.nombreTipoDocumento)
  dispatch(docsDatosReceptorSetErrors({[name]: message}))
}

export const docsDatosReceptorSiguiente = (dispatch: Dispatch<any>, getState: () => State) => {  
  let {form, errors: formError} = getState().documentos.datosReceptor
  if(form.esReceptorManual) {      
    let errors = {...formError}
    errors.tipoDocumento = validacionesOnBlurGeneral('tipoDocumento', form.tipoDocumento, form.nombreTipoDocumento)
    errors.numId = validacionesOnBlurGeneral('numId', form.numId, form.nombreTipoDocumento)
    errors.nombre = validacionesOnBlurGeneral('nombre', form.nombre, form.nombreTipoDocumento)
    dispatch(docsDatosReceptorSetErrors(errors))

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      dispatch(generalOpenModalInfo('Debes completar los datos del responsable receptor. Si no desea ingresar los datos del responsable, deshabilite la opción.'))  
      return true
    }
  }
  return false
}
export const docsDatosReceptorSiguienteDispatch = () => (dispatch: Dispatch<any>, getState: () => State) => {
  return docsDatosReceptorSiguiente(dispatch, getState)
}